import { useContext } from 'react';
import { PermissionEn } from '@martech-solution/utils/constants';
import { AppContext } from 'src/contexts/app.context';
import type { IResourceFullAccessDetail } from 'src/types/master_data/userResource.type';
import { useBasePath } from '@martech-solution/utils/hooks';

function usePermission({ path }: { path?: string }) {
  const { resources } = useContext(AppContext);
  const basePath = useBasePath();

  const getListPermission = () => {
    let _path = path ?? basePath;
    if (_path?.includes('/system-admin/seasonal-employee')) {
      _path = _path.replace('/system-admin/seasonal-employee', '/system-admin/employee');
    }
    // Tìm resource với path chính xác hoặc path là prefix
    const permissions = resources?.find((x) => {
      const resourcePath = x?.path;
      const systemAdminPath = `/system-admin${resourcePath}`;

      return (
        resourcePath === _path ||
        systemAdminPath === _path ||
        _path?.startsWith(resourcePath) ||
        _path?.startsWith(systemAdminPath)
      );
    })?.permissions;
    return permissions;
  };

  const listPermission = getListPermission();
  const isRead = listPermission?.includes(PermissionEn.read);
  const isViewDetail = listPermission?.includes(PermissionEn.viewDetail);
  const isCreate = listPermission?.includes(PermissionEn.create);
  const isUpdate = listPermission?.includes(PermissionEn.update);
  const isDelete = listPermission?.includes(PermissionEn.delete);
  const isApprove = listPermission?.includes(PermissionEn.approve);
  const isReject = listPermission?.includes(PermissionEn.reject);
  const isApprove_solution = listPermission?.includes(PermissionEn.approve_solution);
  const isAssign = listPermission?.includes(PermissionEn.assign);
  const isCreate_leave_ticket = listPermission?.includes(PermissionEn.create_leave_ticket);
  const isAdmin = listPermission?.includes(PermissionEn.admin);
  const isGet_qr = listPermission?.includes(PermissionEn.get_qr);
  const isConfig_field = listPermission?.includes(PermissionEn.config_field);
  const isConfirm_transportation = listPermission?.includes(PermissionEn.confirm_transportation);

  return {
    isRead,
    isViewDetail,
    isCreate,
    isUpdate,
    isDelete,
    isApprove,
    isReject,
    isApprove_solution,
    isAssign,
    isCreate_leave_ticket,
    isAdmin,
    isGet_qr,
    isConfig_field,
    isConfirm_transportation
  };
}

export function usePermissionNew(
  paths?: string[],
  resourcesParam?: IResourceFullAccessDetail[],
  ticketCategoryCode?: string
) {
  const { resources } = useContext(AppContext);
  const basePath = useBasePath();
  const resourceList = resourcesParam ?? resources;

  const getPermissions = () => {
    if (ticketCategoryCode) {
      const permission = resourceList?.find((x) => x?.hrTicketCategoryCode === ticketCategoryCode);
      return permission ? [permission] : [];
    }

    if (!paths) {
      const permission = resourceList?.find((x) => {
        const resourcePath = x?.path;
        const systemAdminPath = `/system-admin${resourcePath}`;

        const isMatch =
          resourcePath === basePath ||
          systemAdminPath === basePath ||
          basePath?.startsWith(resourcePath + '/') ||
          basePath?.startsWith(systemAdminPath + '/');

        return isMatch;
      });

      return permission ? [permission] : [];
    }

    const results = paths
      .map((path) => {
        let checkPath = path;
        if (checkPath?.includes('/system-admin/seasonal-employee')) {
          checkPath = checkPath.replace('/system-admin/seasonal-employee', '/system-admin/employee');
        }

        const permission = resourceList?.find((x) => {
          const resourcePath = x?.path;
          const systemAdminPath = !x?.path?.startsWith('/system-admin/') ? `/system-admin${resourcePath}` : x?.path;

          const isMatch =
            resourcePath === checkPath ||
            systemAdminPath === checkPath ||
            checkPath?.startsWith(resourcePath + '/') ||
            checkPath?.startsWith(systemAdminPath + '/');

          if (checkPath?.startsWith('/partner') && resourcePath?.startsWith('/system-admin/partner')) {
            console.log('  🔍 Checking path:', {
              searchPath: checkPath,
              resourcePath,
              systemAdminPath,
              isMatch
            });
          }

          return isMatch;
        });

        return permission;
      })
      .filter(Boolean);

    return results;
  };

  return getPermissions();
}

export default usePermission;
